import React, { useEffect, useState } from 'react';
import { PayPalButtons, usePayPalScriptReducer } from "@paypal/react-paypal-js";
import { Text, NumberInput, Loader, Divider, Button, Badge, Modal } from '@mantine/core';
import { useNavigate } from 'react-router-dom';
import { useCart } from '../Cart/CartContext';
import { useTranslation } from "react-i18next";
import { DEBUG } from '../..';
import { CartItem, Discount, Product, Cart } from './UseCart';
import { OrderData, LoadOrderDataAsync } from '../OrderList/OrderList';
import { Features, hasFlag } from '../../scripts/FeatureCheck';
import classes from './Checkout.module.css';
import { useSession } from '../../auth/SessionContext';

interface CheckoutProviderProps {
  logged_in: boolean;
  isPending: boolean;
  onApproveNavigation: () => void;
  t: (key: string) => string;
  loadSessionDataAsync: () => Promise<boolean>;
}

interface CheckoutProviderState {
  quantity: number;
  product: Product;
  orderID: string;
  onApproveMessage: string;
  onErrorMessage: string;
  logged_in: boolean;
  isPending: boolean;
  showPreError: boolean;
  showPostError: boolean;
  cart: Cart;
  upgradeableKeys: OrderData[];
}

type UpgradeKeyTupel = [string, string];

const HolidayDiscount: Discount = {
  discount: 5.00,
  start: new Date(2025, 11, 20, 0, 0, 0),
  end: new Date(2025, 11, 31, 23, 59, 59),
  affiliate: ""
}

const ACCACADEMYFounder: Product = {
  name: "ACC ACADEMY",
  value: 40.00,
  tax: 6.39,
  discount: HolidayDiscount
}

const initialState: CheckoutProviderState = {
  quantity: 1,
  product: ACCACADEMYFounder, 
  orderID: "",
  onApproveMessage: "",
  onErrorMessage: "",
  logged_in: false,
  isPending: false,
  showPreError: false,
  showPostError: false,
  cart: new Cart(ACCACADEMYFounder),
  upgradeableKeys: []
};

export class CheckoutProvider extends React.Component<CheckoutProviderProps, typeof initialState> {
  
  activeDiscount = 0.00;
    upgradeableKeys: OrderData[] = [];
  cart: Cart;
  
  async create() {
    const data = await LoadOrderDataAsync();
    if(data === undefined)
      return null;
    else{
      return data.filter(d => !hasFlag(d.features, Features.IRDRIVE));
    }
  }

  constructor(props: CheckoutProviderProps) {
    super(props);
    this.cart = new Cart(ACCACADEMYFounder);
    this.state = {
      ...initialState,
      logged_in: props.logged_in,
      isPending: props.isPending,
      cart: new Cart(ACCACADEMYFounder),
    };

    this.onChange = this.onChange.bind(this);
    this.createOrder = this.createOrder.bind(this);
    this.onApprove = this.onApprove.bind(this);
    this.onError = this.onError.bind(this);
    this.onClick = this.onClick.bind(this);
    
    var now = new Date();
    this.activeDiscount = now >= this.state.product.discount.start && 
                          now <= this.state.product.discount.end ? 
                          this.state.product.discount.discount : 0.00;
  }
  
  async componentDidMount() {
    var upgradeable = await this.create();
    if(upgradeable != null)
      this.upgradeableKeys = upgradeable;
    else
      this.upgradeableKeys = [
        {strSteamId:"76561197985207199",id:708,ident:"b5c98f33-56d1-4859-85af-a404c96d797f",owner:"DEV_loki 76561197985207199",discordId:null,created:"2022-04-03T01:04:09",features:3,refunded:false,steamId:76561197985207199,steamIdBindingTime:"2024-11-08T09:27:06.960529",affiliate:"ACC_DRIVE_TEAM"},
        {strSteamId:"76561197985207200",id:9415,ident:"c7033555-e9aa-4f20-8271-44c7082d70ca",owner:"Manuel Ritter ProTest 76561197985207199",discordId:null,created:"2024-03-27T23:27:08.080991",features:1,refunded:false,steamId:76561197985207200,steamIdBindingTime:"2024-03-27T23:29:43.924618",affiliate:""}
      ];
    
    this.setState({
      upgradeableKeys: this.upgradeableKeys
    });
  }
  
  componentDidUpdate(prevProps: CheckoutProviderProps) {
    if (prevProps.isPending !== this.props.isPending) {
      this.setState({ isPending: this.props.isPending });
    }
  }
  
  onChange(value: any) {
    if(value == "") value = 1;
    this.setState({
      quantity: value,
      orderID: "",
      onApproveMessage: "",
      onErrorMessage: ""
    });
  }
  
  onChangeNew = (value: any) => {
console.log("test");
console.log(value);
    if(value === "" || value.length === 0) value = 1;
    const updatedCart = this.state.cart;
    updatedCart.Items[0].quantity = value;
console.log(updatedCart);
    this.forceUpdate();
  }

  upgradeKey = (key: string) => {
    const updatedCart = this.state.cart;
    updatedCart.AddUpgradeKey(ACCACADEMYFounder, key);
    this.forceUpdate();
  }

  createOrder(data: Record<string, unknown>, actions: any) {
    const ref = localStorage.getItem("ref") ?? "";
    const cartCalc = this.calculateCart();
console.log(this.cart);
console.log(cartCalc);
    var itemList = [];
    if(cartCalc.quantityNew > 0){
      itemList.push({
        name: this.cart.Items[0].product.name,
        description: "New",
        quantity: cartCalc.quantityNew,
        unit_amount: {
          value: cartCalc.valueNewSingle,
          currency_code: "EUR"
        },
        image_url: "https://academy.accsolutions.de/logo192.png",
        url: "https://academy.accsolutions.de/"
      });
    }
    
    if(cartCalc.quantityUpgrade > 0){
      itemList.push({
        name: this.cart.Items[0].product.name,
        description: "Upgrade",
        quantity: cartCalc.quantityUpgrade,
        unit_amount: {
          value: cartCalc.valueUpgradeSingle,
          currency_code: "EUR"
        },
        image_url: "https://academy.accsolutions.de/logo192.png",
        url: "https://academy.accsolutions.de/"
      });
    }
    
    return actions.order
      .create({
        purchase_units: [
          {
            amount: {
              value: cartCalc.totalValue.toFixed(2),
              breakdown: {
                item_total: {
                  value: cartCalc.totalValue.toFixed(2),
                  currency_code: "EUR"
                }
              }
            },
            items: itemList
          }
        ]
      })
      .then((orderID: any) => {
        this.setState({ orderID: orderID });
        return this.logOrder(ref, orderID).then((logOk: boolean) => {
          if (logOk) {
            return orderID; // Zahlung geht weiter
          } else {
            this.setState({ showPreError: true });
            return Promise.reject("Order failed"); // Zahlung wird abgebrochen
          }
        });
      });
  }

  async logOrder(ref: string | null, id: string) {
    const formData = new FormData();
    formData.append('amount', this.state.cart.Quantity().toString());
    formData.append('affiliate', ref ?? "");
    formData.append('id', id);
    formData.append('st', 'CREATED');

    try {
      const response = await fetch('/dyn/process-order.php?mode=create', {
        method: 'POST',
        body: formData,
      });
      
      if (!response.ok) {
        throw new Error('Network response was not ok');
      }
      
      const result = await response.json();
      if (result.success === true) {
      return true;
      } else {
        if (DEBUG) {
          console.error("Order creation failed:", result.error ?? result);
        }
        return false;
      }
    } catch (error: any) {
      if(DEBUG) console.error("Order Error", error.toString());
    }
    return false;
  }

  async handleSubmit(ref: string | null, givenName: string, surName: string, email: string, id: string, status: string) {
    const formData = new FormData();
    const cartCalc = this.calculateCart();
    const quantity = (cartCalc.quantityNew + cartCalc.quantityUpgrade);
    const { cart, upgradeableKeys } = this.state;
    formData.append('amount', quantity.toString());
    formData.append('affiliate', ref ?? "");
    formData.append('em', email);
    formData.append('id', id);
    formData.append('st', status);
    var keys: UpgradeKeyTupel[] = [];
    console.log(cart);
    console.log(cart.Items);
    cart.Items.forEach(element => {
      console.log(element);
      if(element != null && element.upgradeKey != null){
        var uk = upgradeableKeys.find(k => k.ident == element.upgradeKey);
        if(uk != undefined && uk.features != undefined){
          keys.push([element.upgradeKey,(uk.features | Features.ACADEMY).toString()])
        } else {
          keys.push([element.upgradeKey,Features.ACADEMY.toString()])
        }
      }
    });
    formData.append('uk', JSON.stringify(keys));

    try {
      var response: Response;
      response = await fetch('/dyn/process-order.php?mode=new', {
        method: 'POST',
        body: formData,
      });
      
      if (!response.ok) {
        throw new Error('Network response was not ok');
      }
      
      const result = await response.json();
      if (result.success === true) {
        return true;
      } else {
        if (DEBUG) {
          console.error("Order processing failed:", result.error ?? result);
        }
        return false;
      }
    } catch (error: any) {
      if(DEBUG) console.error("Order Error", error.toString());
    }
    return false;
  }

  async handleFin(ref: string | null, id: string, status: string, quantity: string) {
    const formData = new FormData();
    
    formData.append('amount', quantity);
    formData.append('affiliate', ref ?? "");
    formData.append('id', id);
    formData.append('st', status);
    try {
      var response: Response;
      response = await fetch('/dyn/process-order.php?mode=fin', {
        method: 'POST',
        body: formData,
      });
        
      if (!response.ok) {
        throw new Error('Network response was not ok');
      }
      
      const result = await response.json();
    } catch (error: any) {
      if(DEBUG) console.error("Order Error", error.toString());
    }
  }

  onApprove(data: any, actions: any) {
    let app = this;
    const { cart, upgradeableKeys } = this.state;
    
    return actions.order.capture().then(async function (details: any) {
      const ref = localStorage.getItem("ref") ?? "";
      var quantityTotal = 0;
      /*for(var i = 0; i < cart.Items.length; i++){
        quantityTotal += cart.Items[i].quantity;
        await app.handleSubmit(
          ref, 
          details.payer.name.given_name, 
          details.payer.name.surname, 
          details.payer.email_address, 
          details.id, 
          details.status,
          i
        );
      }*/
      await app.handleSubmit(
        ref, 
        details.payer.name.given_name, 
        details.payer.name.surname, 
        details.payer.email_address, 
        details.id, 
        details.status
      ).then((state: boolean) => {
        if (state) {
          app.setState({
            onApproveMessage: `Transaction completed by ${details.payer.name.given_name}!`
          });
        }else{
          app.setState({ showPostError: true });
          return Promise.reject("Order failed"); // Zahlung wird abgebrochen
        }
      });
      //await app.handleFin(ref, details.id, details.status, quantityTotal.toString());
    
      app.setState({
        onApproveMessage: `Transaction completed by ${details.payer.name.given_name}!`
      });
      
      app.props.onApproveNavigation();
    });
  }

  onError(err: Record<string, unknown>) {
    this.setState({
      onErrorMessage: err.toString()
    });
  }

  onClick() {
    if(DEBUG) console.log("When clicked, amount was", this.state.quantity);
  }

  calculateCart() {
    const { cart } = this.state;
    var now = new Date();
    var totalValue = 0;
    var quantityNew = 0;
    var valueNew = 0;
    var valueNewSingle = -1;
    var quantityUpgrade = 0;
    var valueUpgrade = 0;
    var valueUpgradeSingle = -1;
    console.log(cart);
    for(var i = 0; i < cart.Items.length; i++){
      var value = cart.Items[i].product.value - 
        (now >= cart.Items[i].product.discount.start && 
         now <= cart.Items[i].product.discount.end ? 
         cart.Items[i].product.discount.discount : 0.00);
      
    console.log(value);
      totalValue += cart.Items[i].quantity * value;
    console.log(totalValue);
      
      if(i == 0){
        valueNew = cart.Items[i].quantity * value;
        quantityNew = cart.Items[i].quantity;
        if(valueNewSingle === -1)
          valueNewSingle = value;
      } else {
        valueUpgrade += cart.Items[i].quantity * value;
        quantityUpgrade += 1;
        if(valueUpgradeSingle === -1)
          valueUpgradeSingle = value;
      }
    console.log(valueNew);
    }
    
    return {
      totalValue, 
      quantityNew, 
      valueNew, 
      valueNewSingle, 
      quantityUpgrade, 
      valueUpgrade, 
      valueUpgradeSingle
    };
  }

  render() {
    const { cart, upgradeableKeys } = this.state;
    const cartCalc = this.calculateCart();
    const { t } = this.props;
    const now = new Date();
    const isDiscountActive = now >= this.state.product.discount.start && 
                             now <= this.state.product.discount.end;
    
    return (
      <>
        <Modal
          className={classes.errorModal}
          opened={this.state.showPreError || this.state.showPostError}
          onClose={() => this.setState({ showPostError: false, showPreError: false })}
          title={t("cart.error.title")}
          size="lg"
          centered
          closeOnClickOutside={false}
          closeOnEscape={false}
          withCloseButton={false}
          >
          {this.state.showPreError ? (
            <>
              {t("cart.error.preOrderError")}
            </>
          ) : ( <></> )}
          {this.state.showPostError ? (
            <>
              {t("cart.error.postOrderError")} <b>{this.state.orderID}</b>
            </>
          ) : ( <></> )}
          <Button 
              onClick={() => { this.props.loadSessionDataAsync(); this.setState({ showPostError: false, showPreError: false }); }}
              fullWidth
              className={classes.button}
              color={"#FEBF0E"}
              variant="outline">
            {t("cart.error.close")}
          </Button>
        </Modal>        
        {this.state.logged_in ? (
          <div className={classes.checkoutContainer}>
            {this.state.isPending ? (
              <div className={classes.loaderContainer}>
                <Loader color={"#FEBF0E"} size="xl" />
              </div>
            ) : (
              <>
                {/* Upgrade Cards */}
                {/*{upgradeableKeys.length > 0 && (
                  <>
                    <div className={classes.sectionHeader}>
                      <Text className={classes.sectionTitle}>{t('cart.upgrades')}</Text>
                    </div>
                    <div className={classes.upgradeList}>
                      {upgradeableKeys.map((key, index) => {
                        const isUpgraded = cart.HasUpgradeKey(key.ident);
                        const createdDate = new Date(key.created).toLocaleDateString();
                        
                        return (
                          <div className={classes.upgradeCard} key={index}>
                            <div className={classes.upgradeHeader}>
                              <div className={classes.licenseTitle}>
                                <Text className={classes.upgradeTitle}>
                                  {t('cart.license.accDrive')}
                                </Text>
                              </div>
                *}
                              {/* Desktop version: Date + Button side by side */}
                {/*
                              <div className={classes.dateButtonContainer}>
                                <Badge color="blue" variant="light" className={classes.dateBadge}>
                                  {createdDate}
                                </Badge>
                                <Button 
                                  onClick={() => this.upgradeKey(key.ident)} 
                                  className={isUpgraded ? classes.upgradeButton : classes.whiteUpgradeButton}
                                  color={isUpgraded ? "blue" : "white"}
                                  variant="filled"
                                >
                                  {isUpgraded ? t('cart.upgrade.remove') : t('cart.upgrade.upgrade')}
                                </Button>
                              </div>
                *}
                              {/* Mobile version: Date (visible on mobile) */}
                {/*
                              <Badge color="blue" variant="light" className={classes.mobileDateBadge}>
                                {createdDate}
                              </Badge>
                            </div>
                            
                            <div className={classes.upgradeDetails}>
                              <div className={classes.upgradeField}>
                                <Text size="xs" className={classes.fieldLabel}>{t('orders.header.owner')}</Text>
                                <Text className={classes.upgradeValue}>{key.owner}</Text>
                              </div>
                              
                              <div className={classes.upgradeField}>
                                <Text size="xs" className={classes.fieldLabel}>{t('orders.header.key')}</Text>
                                <Text className={classes.upgradeValue} style={{ wordBreak: 'break-all' }}>
                                  {key.ident}
                                </Text>
                              </div>
                              
                              <div className={classes.upgradeField}>
                                <Text size="xs" className={classes.fieldLabel}>{t('orders.header.steam')}</Text>
                                <Text className={classes.upgradeValue}>{key.steamId}</Text>
                              </div>
                            </div>
                *}
                            {/* Mobile version: Button below details */}
                {/*
                            <div className={classes.mobileBtnContainer}>
                              <Button 
                                onClick={() => this.upgradeKey(key.ident)} 
                                className={isUpgraded ? classes.upgradeButton : classes.whiteUpgradeButton}
                                color={isUpgraded ? "blue" : "white"}
                                variant="filled"
                                fullWidth
                              >
                                {isUpgraded ? t('cart.upgrade.remove') : t('cart.upgrade.upgrade')}
                              </Button>
                            </div>
                          </div>
                        );
                      })}
                    </div>
                  </>
                )}
                *}
                
                {/* New Licenses Section */}
                <div className={classes.sectionHeader}>
                  <Text className={classes.sectionTitle}>
                    {t('cart.newLicenses')}
                    <span 
                      className={classes.giftInfo} 
                      data-tooltip={t('cart.giftTooltip') || "You can purchase multiple licenses and gift them to friends. Each license will be available in your account for assignment."}
                    >
                      {t('cart.giftInfo') || "How to gift?"}
                    </span>
                  </Text>
                </div>

                {/* License Card */}
                <div className={classes.licenseCard}>
                  <div className={classes.licenseInfo}>
                    <img 
                      src="logo192.png" 
                      alt="ACC ACADEMY" 
                      className={classes.licenseLogo} 
                    />
                    <Text className={classes.licenseTitle}>
                      {this.state.product.name} {t('cart.founder')}
                    </Text>
                  </div>
                  <div className={classes.licenseQuantity}>
                    <div className={classes.quantityInput}>
                      <NumberInput
                        className={classes.styledInput}
                        min={1}
                        max={50}
                        stepHoldDelay={500}
                        stepHoldInterval={100}
                        allowDecimal={false}
                        allowNegative={false}
                        value={cart.Items[0].quantity}
                        onChange={this.onChangeNew}
                        clampBehavior="strict"
                        hideControls={true}
                        styles={{
                          root: { width: '100%', maxWidth: '100px', justifySelf: 'end' },
                          input: { 
                            width: '100%',
                            textAlign: 'center',
                            fontSize: '30px',
                            fontWeight: 'bold',
                            fontFamily: 'RobotoMedium',
                            height: '55px',
                          }
                        }}
                      />
                      {/* Custom triangle arrows */}
                      <div className={classes.arrowUp}></div>
                      <div className={classes.arrowDown}></div>
                      
                      {/* Custom button overlays for better click targets */}
                      <button 
                        className={`${classes.spinButton} ${classes.spinUp}`}
                        onClick={() => this.onChangeNew(Math.min(50, cart.Items[0].quantity + 1))}
                        aria-label="Increase quantity"
                        type="button"
                      />
                      <button 
                        className={`${classes.spinButton} ${classes.spinDown}`}
                        onClick={() => this.onChangeNew(Math.max(1, cart.Items[0].quantity - 1))}
                        aria-label="Decrease quantity"
                        type="button"
                      />
                    </div>
                  </div>
                </div>
                
                {/* Order Summary */}
                <div className={classes.summaryContainer}>
                  <Text className={classes.summaryTitle}>{t('cart.summary')}</Text>
                  
                  <div className={classes.summaryRow}>
                    <Text>{cart.Items[0].product.name}</Text>
                    <div className={classes.summaryValues}>
                      <Text className={classes.summaryQuantity}>{cart.Items[0].quantity}x</Text>
                      
                      {isDiscountActive ? (
                        <div className={classes.priceWithDiscount}>
                          <Text className={`${classes.originalPrice} ${classes.strikethrough}`}>
                            {(cart.Items[0].product.value * cart.Items[0].quantity).toFixed(2)}€
                          </Text>
                          <Text>
                            {((cart.Items[0].product.value - this.activeDiscount) * cart.Items[0].quantity).toFixed(2)}€
                          </Text>
                        </div>
                      ) : (
                        <Text>{(cart.Items[0].product.value * cart.Items[0].quantity).toFixed(2)}€</Text>
                      )}
                    </div>
                  </div>
                  
                  <Divider className={classes.summaryDivider} />
                  
                  <div className={classes.summaryTotal}>
                    <Text fw={700}>{t('cart.total')}</Text>
                    <Text fw={700} size="xl" className={classes.totalAmount}>
                      {((cart.Items[0].product.value - this.activeDiscount) * cart.Items[0].quantity).toFixed(2)}€
                    </Text>
                  </div>

                  <div className={classes.taxInformation}>
                    <Text size="xs" c="dimmed">{t('cart.vat')}</Text>
                  </div>
                </div>
                
                {/* Payment Buttons */}
                <div className={classes.paymentSection}>
                  <PayPalButtons
                    style={{ layout: "vertical", color: "gold", shape: "rect" }}
                    createOrder={this.createOrder}
                    onApprove={this.onApprove}
                    onError={this.onError}
                  />
                </div>
              </>
            )}
          </div>
        ) : (
          <></>
        )}
      </>
    );
  }
}

export const Checkout = (logged_in: any) => {
  const { closeCart } = useCart();
  const navigate = useNavigate();
  const { t } = useTranslation("translation");
  const { loadSessionDataAsync } = useSession();
  const redirectToProfile = () => {
    closeCart();
    navigate("/account");
  };

  const [{ options, isPending }, dispatch] = usePayPalScriptReducer();
  
  return (
    <CheckoutProvider 
      logged_in={logged_in} 
      isPending={isPending} 
      onApproveNavigation={redirectToProfile} 
      t={t} 
      loadSessionDataAsync={loadSessionDataAsync}
    />
  );
}